require('angular').module('wowApp.common')
    .service('PastShopService', ['Restangular', '$q', 'BootstrapService', require('./pastshop.service')]);



// WEBPACK FOOTER //
// ./src/common/pastshops/index.js